import { Link } from 'react-router-dom';
import { useUsers, useDeleteUser } from './api';
import { useAuthStore } from '../auth/store';

export function UserList(): JSX.Element {
  const { data, isLoading, isError, error } = useUsers();
  const deleteMutation = useDeleteUser();
  const me = useAuthStore((s) => s.user);

  if (isLoading) return <div role="status" className="text-slate-500">載入中...</div>;
  if (isError) {
    return (
      <div role="alert" className="text-red-600">
        載入失敗：{error instanceof Error ? error.message : '未知錯誤'}
      </div>
    );
  }

  const users = data?.data ?? [];
  if (users.length === 0) return <div className="text-slate-500">目前沒有使用者</div>;

  const onDelete = (id: number, name: string) => {
    if (!window.confirm(`確定要停用 ${name} 嗎？`)) return;
    deleteMutation.mutate(id);
  };

  return (
    <table className="w-full bg-white shadow-sm rounded-md">
      <thead>
        <tr className="border-b text-left text-sm text-slate-600">
          <th className="px-4 py-2">Username</th>
          <th className="px-4 py-2">姓名</th>
          <th className="px-4 py-2">Email</th>
          <th className="px-4 py-2">角色</th>
          <th className="px-4 py-2">啟用</th>
          <th className="px-4 py-2">動作</th>
        </tr>
      </thead>
      <tbody>
        {users.map((u) => {
          const isSelf = me?.id === u.id;
          return (
            <tr key={u.id} className="border-b last:border-0 hover:bg-slate-50">
              <td className="px-4 py-2 font-mono text-sm">{u.username}</td>
              <td className="px-4 py-2">{u.displayName}</td>
              <td className="px-4 py-2">{u.email}</td>
              <td className="px-4 py-2">
                <span className="inline-block rounded bg-slate-100 px-2 py-0.5 text-xs">
                  {u.role}
                </span>
              </td>
              <td className="px-4 py-2">{u.isActive ? '✔' : '—'}</td>
              <td className="px-4 py-2 flex gap-2">
                <Link
                  to={`/settings/users/${u.id}/edit`}
                  className="text-blue-600 hover:underline text-sm"
                >
                  編輯
                </Link>
                {isSelf ? null : (
                  <button
                    type="button"
                    onClick={() => onDelete(u.id, u.displayName)}
                    className="text-red-600 hover:underline text-sm"
                  >
                    停用
                  </button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
